/* Product page (3.0 Refresh, ported from Adro 4.0). Loaded from sections/main-product.liquid.
   1. Description cleanup: hides empty spacer paragraphs and stray line breaks
   2. "Have questions?" opens the chat
   3. "More for the [vehicle]": mixes the areas, then runs the carousel (arrows, page count)
   4. Gallery: thumbnail strip fade, mouse wheel scrolling, keeps the active thumbnail in view
   5. Desktop: lines Overview up with the photo and Details with the buy column
   6. Customer Reviews heading number (Safari can't count through the Judge.me widget, so it showed 00) */
(function () {
  /* 1. Description cleanup */
  function cleanDescription(root) {
    root.querySelectorAll('.pdp4-desc p').forEach(function (p) {
      var isBlank = function (node) { return node && node.nodeType === 3 && !node.textContent.replace(/ /g, ' ').trim(); };
      var trim = function () {
        while (isBlank(p.firstChild)) p.firstChild.remove();
        while (isBlank(p.lastChild)) p.lastChild.remove();
      };
      trim();
      while (p.firstChild && p.firstChild.nodeName === 'BR') { p.firstChild.remove(); trim(); }
      while (p.lastChild && p.lastChild.nodeName === 'BR') { p.lastChild.remove(); trim(); }
      if (!p.querySelector('img, iframe, video') && !p.textContent.replace(/ /g, ' ').trim()) p.classList.add('pdp4-empty');
    });
  }

  /* 2. Chat */
  function findDeep(root, selector) {
    var hit = root.querySelector(selector);
    if (hit) return hit;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) {
        var inner = findDeep(all[i].shadowRoot, selector);
        if (inner) return inner;
      }
    }
    return null;
  }

  function bindChat(root) {
    root.querySelectorAll('[data-pdp-chat]').forEach(function (button) {
      button.addEventListener('click', function () {
        var activator = findDeep(document, '[part="activator"]');
        if (activator) activator.click();
      });
    });
  }

  /* 3. More for the [vehicle]
     Desktop: one row, the arrows scroll a full row. Phones: 2 x 2 pages, swiped.
     The arrows and the 01 / 05 page count hide when everything already fits. */
  function initMore(section) {
    var grid = section.querySelector('[data-pdp-grid]');
    if (!grid) return;
    var items = Array.prototype.slice.call(grid.querySelectorAll('.product__picker__item'));
    if (!items.length) { section.hidden = true; return; }

    /* mix areas: front, side, rear, wing, other, then repeat, so the first row shows variety */
    var order = ['front', 'side', 'rear', 'wing', 'other'];
    var groups = {};
    items.forEach(function (item) {
      var area = (item.dataset.area || 'other').trim();
      item.dataset.area = area;
      (groups[area] = groups[area] || []).push(item);
    });
    var added = true;
    while (added) {
      added = false;
      order.forEach(function (area) {
        if (groups[area] && groups[area].length) { grid.appendChild(groups[area].shift()); added = true; }
      });
    }

    var nav = section.querySelector('[data-pdp-more-nav]');
    var prev = section.querySelector('[data-pdp-more-prev]');
    var next = section.querySelector('[data-pdp-more-next]');
    var count = section.querySelector('[data-pdp-more-count]');
    var gap = function () { return parseFloat(getComputedStyle(grid).columnGap) || 0; };
    var step = function () { return grid.clientWidth + gap(); };
    var pageCount = function () { return Math.max(1, Math.ceil((grid.scrollWidth - 2) / step())); };
    var pageIndex = function () { return Math.round(grid.scrollLeft / step()); };

    var pad = function (n) { return (n < 10 ? '0' : '') + n; };

    var update = function () {
      var scrollable = grid.scrollWidth > grid.clientWidth + 2;
      if (nav) nav.hidden = !scrollable;
      if (prev) prev.disabled = grid.scrollLeft <= 2;
      if (next) next.disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
      if (count) {
        var total = pageCount();
        /* at the very end the last page can be a partial one, so count it as the last page */
        var current = next && next.disabled ? total - 1 : Math.min(pageIndex(), total - 1);
        count.innerHTML = '<b>' + pad(current + 1) + '</b> / ' + pad(total);
        count.setAttribute('aria-label', 'Page ' + (current + 1) + ' of ' + total);
      }
    };

    if (prev) prev.addEventListener('click', function () { grid.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { grid.scrollBy({ left: step(), behavior: 'smooth' }); });
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* 4. Gallery */
  function initGallery(root) {
    var thumbEl = root.querySelector('.thumbnail-slider');
    var mainEl = root.querySelector('.product__main-slider');
    if (!thumbEl || !mainEl) return;
    var tries = 0;

    (function waitForSwiper() {
      if (!thumbEl.swiper || !mainEl.swiper) {
        if (++tries < 50) setTimeout(waitForSwiper, 100);
        return;
      }
      var ts = thumbEl.swiper;
      var ms = mainEl.swiper;
      var desktop = window.matchMedia('(min-width: 990px)');

      var edges = function () {
        var scrollable = desktop.matches && ts.virtualSize > ts.size + 1;
        thumbEl.classList.toggle('pdp4-more-above', scrollable && !ts.isBeginning);
        thumbEl.classList.toggle('pdp4-more-below', scrollable && !ts.isEnd);
      };
      ['progress', 'setTranslate', 'resize', 'slideChange', 'transitionEnd'].forEach(function (name) { ts.on(name, edges); });
      edges();

      /* mouse wheel over the strip scrolls it */
      thumbEl.addEventListener('wheel', function (event) {
        if (!desktop.matches || ts.virtualSize <= ts.size + 1) return;
        event.preventDefault();
        var next = Math.max(ts.maxTranslate(), Math.min(ts.minTranslate(), ts.translate - event.deltaY));
        ts.setTransition(0);
        ts.setTranslate(next);
        ts.updateProgress();
        ts.updateActiveIndex();
        ts.updateSlidesClasses();
        edges();
      }, { passive: false });

      /* keep the active thumbnail in view when the main photo changes */
      ms.on('slideChange', function () {
        if (!desktop.matches) return;
        var slide = ts.slides[ms.activeIndex];
        if (!slide) return;
        var top = slide.swiperSlideOffset;
        var bottom = top + slide.offsetHeight;
        var viewTop = -ts.translate;
        var viewBottom = viewTop + ts.size;
        if (top < viewTop || bottom > viewBottom) {
          var target = Math.max(ts.maxTranslate(), Math.min(ts.minTranslate(), -(top - (ts.size - slide.offsetHeight) / 2)));
          ts.setTransition(300);
          ts.setTranslate(target);
          ts.updateProgress();
          setTimeout(edges, 320);
        }
      });
    })();
  }

  /* 5. Overview under the photo, Details under the buy column (desktop only) */
  function alignRow(root) {
    var row = root.querySelector('.pdp4-row');
    var media = root.querySelector('.product__media-wrapper');
    var info = root.querySelector('.product__info-container');
    if (!row || !media || !info) return;
    var desktop = window.matchMedia('(min-width: 990px)');

    var apply = function () {
      if (!desktop.matches) {
        row.style.removeProperty('--pdp-col-main');
        row.style.removeProperty('--pdp-col-gap');
        return;
      }
      var m = media.getBoundingClientRect();
      var i = info.getBoundingClientRect();
      var r = row.getBoundingClientRect();
      var mainWidth = Math.round(m.right - r.left);
      var colGap = Math.round(i.left - m.right);
      if (mainWidth <= 0 || colGap < 0) return;
      row.style.setProperty('--pdp-col-main', mainWidth + 'px');
      row.style.setProperty('--pdp-col-gap', colGap + 'px');
    };

    apply();
    if (window.ResizeObserver) new ResizeObserver(apply).observe(root);
    else window.addEventListener('resize', apply);
  }

  /* 6. Reviews number: count the visible numbered headings before the reviews block, add 1.
     The CSS falls back to the automatic counter if this doesn't run. */
  function numberReviews() {
    var block = document.querySelector('.shopify-app-block[id*="reviews_review_widget"]');
    if (!block) return;
    var before = Array.prototype.filter.call(document.querySelectorAll('.pdp4-sec'), function (sec) {
      return sec.getClientRects().length && (sec.compareDocumentPosition(block) & Node.DOCUMENT_POSITION_FOLLOWING);
    });
    var n = before.length + 1;
    block.style.setProperty('--pdp-sec-num', '"' + (n < 10 ? '0' : '') + n + '"');
  }

  function init() {
    document.querySelectorAll('.pdp4').forEach(function (root) {
      cleanDescription(root);
      bindChat(root);
      root.querySelectorAll('[data-pdp-more]').forEach(initMore);
      initGallery(root);
      alignRow(root);
    });
    numberReviews();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
